
import FontFaceObserver from 'fontfaceobserver'
import { useTextFit } from './useTextFit'

export const useUseRenderText = ({ layer, name, wish, template }) => {

  const { drawTextToFitArea } = useTextFit()

  let textClone = null
  let wrapped = null
  init()

  return {

  }

  function init() {
    // วาดรอบแรกด้วยฟอนต์ที่มีอยู่ตอนนี้ เพื่อให้เห็นข้อความเร็ว
    applyAutoSize()
    // แล้วคำนวณใหม่อีกครั้งเมื่อฟอนต์จริงโหลดเสร็จ
    loadFonts()
  }

  function applyAutoSize() {

    wrapped && wrapped.destroy()
    textClone && textClone.destroy()
    // WISH
    if (wish) {
      // create wrapped texts
      if (wish.getAttrs().words) {
        textClone = wish.clone()
        wrapped = wrappedWishText(textClone, wish.getAttrs().words, wish.getAttrs().autoSize || [30, 48])
        layer.add(wrapped)
        // layer.add() จะ append ไปบนสุดเสมอ ทำให้รอบที่สอง (หลังฟอนต์โหลดเสร็จ)
        // แทรกขึ้นเหนือ loading overlay — ตรึงไว้ที่ตำแหน่งเหนือ wish node เดิมแทน
        wrapped.zIndex(wish.zIndex() + 1)
        // remove original text
        wish.text('')

      }

    }

    if (name) {
      // let maxFontSize = Math.max(32, name.fontSize())
      // fontAutoSize(name, [24, maxFontSize])
      fontAutoSize(name, [name.fontSize(), 38])
      //nothing to do
    }
  }

  function addCssLink(fontFamily: string) {

    if (!fontFamily) {
      return
    }

    //only font for photowish template
    // const url = 'https://fonts.googleapis.com/css2?family=' + fontFamily  + ':wght@400;700' // + '&display=swap'
    const url = 'https://fonts.googleapis.com/css2?family=' + fontFamily      // + '&display=swap'
    const encoded = encodeURI(url)

    //check if link already exists in head
    let linkExists = false
    document.querySelectorAll('link').forEach((link) => {
      if (link.href == encoded) {
        linkExists = true
      }
    })

    if (linkExists) {
      return
    }


    const link = document.createElement('link')
    link.rel = 'stylesheet'
    link.href = encoded
    document.head.appendChild(link)
  }


  function fontAutoSize(textElement, _autoSize = [22, 48]) {

    // get rect of text element

    let { x, y, width, height, autoSize, text } = textElement.getAttrs()


    let [min, max] = _autoSize

    //do auto size
    let count = 0
    let _fontSize = min
    textElement.fontSize(min)

    let text_removed_all_spaces = text.replace(/ +/g, '');

    // text remove all newlines
    let text_removed_all_newlines = text_removed_all_spaces.replace(/(\r\n|\n|\r)/gm, "");

    while (hasEmptySpace(textElement, text_removed_all_newlines, _fontSize + 1) && (_fontSize + 1) <= max && count < 40) {
      _fontSize++
      count++
    }
    textElement.fontSize(_fontSize)


    console.log(`${textElement.name()} autosize font at : `, _fontSize)

    function hasEmptySpace(container, text_removed_all_spaces, nextFontSize) {
      container.fontSize(nextFontSize)

      let sum = 0
      for (let index = 0; index < container.textArr.length; index++) {
        const element = container.textArr[index].text.replace(/ +/g, '');

        sum += element.length;
      }

      if (sum == text_removed_all_spaces.length) {
        return true
      } else {
        return false
      }


    }
  }

  function wrappedWishText(element: any, words: Array<string>, _autoSize = [22, 48]) {
    let shape = new Konva.Shape({
      x: element.x() || 0,
      y: element.y() || 0,
      width: element.width(),
      height: element.height(),
      fontFamily: element.fontFamily(),

      sceneFunc: function (context, shape) {

        drawTextToFitArea(context, words, element.width(), element.height(), {
          minFontSize: _autoSize[0],
          maxFontSize: _autoSize[1],
          verticalAlign: element.verticalAlign() || "top",
          horizontalAlign: element.align() || "left",
          fontFamily: element.fontFamily() || "Arial",
          // fontWeight: "bold",
          letterSpacing: element.letterSpacing() || 0,
          lineHeight: element.lineHeight() || 1.5,
          fill: element.fill() || "black",
        });
      }
    });

    return shape;
  }

  async function loadFonts() {

    let fontName = name && name.fontFamily()
    let fontWish = wish && wish.fontFamily()

    addCssLink(fontName)
    addCssLink(fontWish)

    try {
      await Promise.all([
        loadGoogleOrCustomFont(name),
        loadGoogleOrCustomFont(wish),
      ])
      console.log('all text loaded')
    } catch (e) {
      console.log('error loading text', e)
    }

    // FontFaceObserver กับ <link> จะ resolve ตั้งแต่ CSS มาถึง ซึ่งไฟล์ฟอนต์อาจยังโหลดไม่เสร็จ
    // ต้องสั่งโหลดไฟล์ฟอนต์ตรง ๆ แล้วรอ document.fonts.ready ก่อนวัดข้อความ
    await ensureDocumentFontsLoaded([fontName, fontWish])

    // คำนวณ autosize ใหม่ด้วยฟอนต์จริง
    applyAutoSize()
    layer.batchDraw()
  }

  async function ensureDocumentFontsLoaded(fontFamilies: Array<string>) {
    if (typeof document === 'undefined' || !document.fonts?.load) {
      return
    }

    const families = fontFamilies.filter(Boolean)

    try {
      await Promise.all(families.map(family => document.fonts.load(`16px "${family}"`)))
      await document.fonts.ready
    } catch (e) {
      console.log('error waiting for fonts', e)
    }
  }

  function loadGoogleOrCustomFont(textNode:any) {
    if(!textNode?.attrs) {
      return
    }

    // custom_font
    if(textNode?.attrs?.customFont?.type === 'custom_font') {
      const replaceSpace = textNode?.attrs?.customFont?.url?.replaceAll(' ', '+')
      const fontTarget = new FontFace(
        textNode?.attrs?.fontFamily,
        `url(${replaceSpace})`,
      );

      document.fonts.add(fontTarget);
      return  new FontFaceObserver(textNode?.attrs?.fontFamily).load(null);
    }

    // google_font
    return new FontFaceObserver(textNode?.attrs?.fontFamily).load(null)
  } 



}
